import { useAuth } from "@clerk/clerk-react";
import { useTheme } from "@heroui/react";
import { Outlet } from "react-router";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import AuthLoadingScreen from "@/components/loading/auth";
import { isMockEnabled } from "@/mock";
import PwaUpdatePrompt from "@/components/pwa/update-prompt";
import { TOAST_WIDTH, ToastProvider } from "@/utils/toast";

export default function RootLayout() {
  const { isLoaded } = useAuth();

  useTheme();

  // Mock mode runs with no Clerk session, so `isLoaded` never flips and this
  // gate would hold the whole app on the sign-in screen - the same bypass
  // `components/auth/route.tsx` and `providers/bootstrap.tsx` already carry.
  if (!isLoaded && !isMockEnabled()) {
    return (
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <ToastProvider width={TOAST_WIDTH} />
        <main className="text-foreground !overflow-x-hidden">
          <AuthLoadingScreen />
        </main>
      </QueryParamProvider>
    );
  }

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <ToastProvider placement="bottom end" width={TOAST_WIDTH} />
      <div className="text-foreground min-h-dvh h-full">
        <Outlet />
      </div>
      <PwaUpdatePrompt />
    </QueryParamProvider>
  );
}
